window.samples = {


  init: () => {

    let ls_collapsed = localStorage.getItem('samples_collapsed'),
        grid = document.querySelector('.samples-products-grid'),
        details = document.querySelector('.samples-products-grid__details');
    
    if (details) {
      setTimeout(()=>{
        details.classList.add('transition_is_set');
      }, 400);
    }

    if (ls_collapsed == null) {
      grid.setAttribute('data-samples-collapsed', 0);
    } else {
      if (grid) {
        grid.setAttribute('data-samples-collapsed', ls_collapsed);
      }
    }

    window.samples.addListeners();
    window.samples.updateCards();

  },


  addListeners: () => {

    // console.log('addListeners');

    let buttons_add = document.querySelectorAll('.card-btn-sample-add:not(.event_is_set)'),
        buttons_remove = document.querySelectorAll('.card-btn-sample-remove:not(.event_is_set)'),
        buttons_remove_list = document.querySelectorAll('.samples-products-grid__details .sample-product__remove:not(.event_is_set)'),
        buttons_sample_details = document.querySelectorAll('.card-btn-sample-details:not(.event_is_set)'),
        icons_sample_details = document.querySelectorAll('.sample-details-icon:not(.event_is_set)'),
        buttons_sample_details_close = document.querySelectorAll('.sample-details .box__close:not(.event_is_set)'),
        button_add_samples = document.querySelectorAll('.btn-add-samples:not(.event_is_set)'),
        details_arrow = document.querySelector('.samples-products-grid__details .box__arrow:not(.event_is_set)');

    if (buttons_add.length) {
      buttons_add.forEach((button) => {
        button.addEventListener('click', () => {
          let parent = button.closest('.product-card-sample-wrapper'),
              id = parent.getAttribute('data-sample-id'),
              title = parent.getAttribute('data-sample-title'),
              image = parent.getAttribute('data-sample-image');
          window.samples.addProductToLs(id, title, image);
        });
        button.classList.add('event_is_set');
      });
    }

    if (buttons_remove.length) {
      buttons_remove.forEach((button) => {
        button.addEventListener('click', () => {
          let parent = button.closest('.product-card-sample-wrapper'),
              id = parent.getAttribute('data-sample-id');
          window.samples.removeProductFromLs(id);
        });
        button.classList.add('event_is_set');
      });
    }

    if (buttons_remove_list.length) {
      buttons_remove_list.forEach((button) => {
        button.addEventListener('click', () => {
          let parent = button.closest('.sample-product'),
              id = parent.getAttribute('data-sample-id');
          window.samples.removeProductFromLs(id);
        });
        button.classList.add('event_is_set');
      });
    }

    if (buttons_sample_details.length) {
      buttons_sample_details.forEach((button) => {
        button.addEventListener('click', () => {
          let id = button.getAttribute('data-sample-id');
          window.samples.openSampleDetails(id);
        });
        button.classList.add('event_is_set');
      });
    }

    if (icons_sample_details.length) {
      icons_sample_details.forEach((button) => {
        button.addEventListener('click', () => {
          button.closest('.card').querySelector('.card-btn-sample-details').click();
        });
        button.classList.add('event_is_set');
      });
    }

    if (buttons_sample_details_close.length) {
      buttons_sample_details_close.forEach((button) => {
        button.addEventListener('click', () => {
          window.samples.closeSampleDetails();
        });
        button.classList.add('event_is_set');
      });
    }

    if (button_add_samples.length) {
      button_add_samples.forEach((button) => {
        button.addEventListener('click', () => {
          if (!button.classList.contains('is_loading')) {
            button.classList.add('is_loading');
            window.samples.addProductsToCart();
          }
        });
        button.classList.add('event_is_set');
      });
    }

    if (details_arrow) {
      details_arrow.addEventListener('click', (item) => {
        let parent = item.currentTarget.closest('.samples-products-grid'),
            collapsed = parent.getAttribute('data-samples-collapsed');
        if (collapsed == '1') {
          parent.setAttribute('data-samples-collapsed', 0);
          localStorage.setItem('samples_collapsed', 0);
        } else {
          parent.setAttribute('data-samples-collapsed', 1);
          localStorage.setItem('samples_collapsed', 1);
        }
      });
      details_arrow.classList.add('event_is_set');
    }

  },


  addProductToLs: (_id, _title, _image) => {

    // console.log('addProductToLs');

    let grid = document.querySelector('.samples-products-grid'), 
        max_products = parseFloat(grid.getAttribute('data-samples-max-products')),
        samples_ls_value = localStorage.getItem('samples'),
        samples_ls_array = samples_ls_value != null ? JSON.parse(samples_ls_value) : [],
        product_exist_in_ls = false,
        new_value = false;

    let new_product = {
      id: _id,
      title: _title,
      image: _image
    };

    if (samples_ls_array.length == 0) {
      
      new_value = [new_product];
    
    } else {

      if (max_products > samples_ls_array.length) {
        for (let i = 0; i < samples_ls_array.length; i++) {
          if (samples_ls_array[i].id == _id) {
            product_exist_in_ls = true;
          }
        }

        if (product_exist_in_ls == false) {
          new_value = samples_ls_array;
          new_value[samples_ls_array.length] = new_product;
        }
      } else {
        window.samples.showLimit();
      }

    }

    if (new_value != false) {
      localStorage.setItem('samples', JSON.stringify(new_value));
    }

    window.samples.updateCards();

  },


  removeProductFromLs: (_id) => {

    // console.log('removeProductFromLs');

    let samples_ls_value = localStorage.getItem('samples'),
        samples_ls_array = samples_ls_value != null ? JSON.parse(samples_ls_value) : [],
        new_value = [];

    if (samples_ls_array.length == 0) {

      localStorage.removeItem('samples');
    
    } else {

      for (let i = 0; i < samples_ls_array.length; i++) {
        if (samples_ls_array[i].id != _id) {
          new_value.push(samples_ls_array[i]);
        }
      }

      if (new_value.length == 0) {
        localStorage.removeItem('samples');
      } else {
        localStorage.setItem('samples', JSON.stringify(new_value));
      }
      
    }

    window.samples.updateCards();

  },


  updateCards: () => {

    // console.log('updateCards');

    let cards = document.querySelectorAll('.product-card-sample-wrapper'),
        samples_ls_value = localStorage.getItem('samples'),
        samples_ls_array = samples_ls_value != null ? JSON.parse(samples_ls_value) : [],
        samples_ls_array_ids = [];

    if (cards.length) {
      if (samples_ls_array.length == 0) {

        cards.forEach((card) => {
          card.setAttribute('data-sample-ls', 0);
        });

      } else {

        for (let i = 0; i < samples_ls_array.length; i++) {
          samples_ls_array_ids.push(samples_ls_array[i].id);
        }
  
        cards.forEach((card) => {
          let id = card.getAttribute('data-sample-id');
          if (samples_ls_array_ids.includes(id)) {
            card.setAttribute('data-sample-ls', 1);
          } else {
            card.setAttribute('data-sample-ls', 0);
          }
        });

      }
  
    }

    window.samples.updateList();
  },


  updateList: () => {

    // console.log('updateList');

    let grid = document.querySelector('.samples-products-grid'), 
        list = document.querySelector('.samples-products-grid__details .sample-products'),
        data_t_remove = list.getAttribute('data-t-remove'),
        new_list_html = '',
        samples_ls_value = localStorage.getItem('samples'),
        samples_ls_array = samples_ls_value != null ? JSON.parse(samples_ls_value) : [];


    if (grid) {
      grid.setAttribute('data-samples-products', samples_ls_array.length);
    }

    if (list) {
      if (samples_ls_array.length == 0) {
        list.innerHTML = '';
      } else {
        for (let i = 0; i < samples_ls_array.length; i++) {
          new_list_html += `
            <div class="sample-product" data-sample-id="${samples_ls_array[i].id}">
              <div class="sample-product__image"><img src="${samples_ls_array[i].image}" alt="${samples_ls_array[i].title}"></div>
              <div class="sample-product__title">${samples_ls_array[i].title}</div>
              <div class="sample-product__remove">${data_t_remove}</div>
            </div>
          `;
        };
        list.innerHTML = new_list_html;
      }
    }

    window.samples.addListeners();
    window.samples.checkLimit();

  },


  checkLimit: () => {

    let samples_ls_value = localStorage.getItem('samples'),
        samples_ls_array = samples_ls_value != null ? JSON.parse(samples_ls_value) : [],
        grid = document.querySelector('.samples-products-grid'), 
        data_products = false,
        data_max_products = parseFloat(grid.getAttribute('data-samples-max-products'));


    if (samples_ls_array.length == 0) {
      
      data_products = 0;
      grid.setAttribute('data-samples-products', data_products);

    } else {
      
      data_products = samples_ls_array.length;
      grid.setAttribute('data-samples-products', data_products);
    
    }

    if (grid) {
      if (data_products >= data_max_products) {
        grid.setAttribute('data-samples-limit', 1);
      } else {
        grid.setAttribute('data-samples-limit', 0);
      }
    }
    
  },


  clearLs: () => {

    localStorage.removeItem('samples');
    localStorage.removeItem('samples_collapsed');

  },


  addProductsToCart: () => {

    let samples_ls_value = localStorage.getItem('samples'),
        samples_ls_array = samples_ls_value != null ? JSON.parse(samples_ls_value) : [],
        prev_samples_products = document.querySelector('[data-cart-samples-products]'),
        prev_samples_products_array = prev_samples_products ? prev_samples_products.getAttribute('data-cart-samples-products').split('|') : false,
        data = {
          'items': []
        };
    
    for (let i = 0; i < samples_ls_array.length; i++) {
      let sample = {
        'id': parseFloat(samples_ls_array[i].id),
        'quantity': 1
      };
      data.items.push(sample);
    }

    if (samples_ls_array.length > 0) {
      if (prev_samples_products_array == false) {
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then(response => {
          window.samples.clearLs();
          window.location.href = '/cart';
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }
      
      if (prev_samples_products_array.length > 0) {

        let prev_samples_products_array_urls = [];
        prev_samples_products_array.forEach((item) => {
          prev_samples_products_array_urls.push(`${window.Shopify.routes.root}cart/change.js?id=${item}&quantity=0`);
        });

        async function removePrevSampleAddNew(_array) {
          for (let _item of _array) {
            let response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ id: _item, quantity: 0 })
            });
            // console.log('key', _item);
            // console.log(await response.json());
          }
            
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          })
          .then(response => {
            window.samples.clearLs();
            window.location.href = '/cart';
            return response.json();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        }
        
        removePrevSampleAddNew(prev_samples_products_array);

      }
    }

  },


  openSampleDetails: (id) => {
    
    let active_samples = document.querySelectorAll('.sample-details.is_active'),
        sample_details = document.querySelector(`.sample-details[data-sample-id="${id}"]`);
    
    if (active_samples.length) {
      active_samples.forEach((item) => {
        item.classList.remove('is_active');
      });
    }

    if (sample_details) {

      sample_details.classList.add('is_active');
      document.body.setAttribute('data-sample-details', id);

    }

  },


  closeSampleDetails: (id) => {
    
    if (id) {

      let sample_details = document.querySelector(`.sample-details[data-sample-id="${id}"]`);
      if (sample_details) {
        sample_details.classList.remove('is_active');
      }

    } else {

      let active_samples = document.querySelectorAll('.sample-details.is_active');
      if (active_samples.length) {
        active_samples.forEach((item) => {
          item.classList.remove('is_active');
        });
      }

    }

    document.body.removeAttribute('data-sample-details');

  }


};

window.samples.init();
